<template>
    <div class="pic">
        <img @click="goBusinessClick" src="../../assets/active.jpg">
    </div>
</template>


<script>

export default {
    name: 'activityBusinessIndex',
    methods: {
        goBusinessClick(){
            this.$router.push({
                path:'/aIdx'
            });
        }
    }
}
</script>



<style>
.pic{
    width: 100%;
}


.pic img{
    width: 100%;
    vertical-align: middle;
    display: block;
}
</style>

